export default {
  title: 'Maksa Pixillä',
  hint: 'Kopioi koodi ja liitä se Pixiin pankkisovelluksessasi, tai skannaa QR-koodi sillä.',
  copy: 'Kopioi Pix-koodi',
  copied: 'Koodi kopioitu',
  qr_alt: 'Pix QR-koodi',
  expires_in: 'Koodi vanhenee {{time}} kuluttua',
  waiting: 'Vahvistamme tilauksesi heti, kun pankkisi lähettää maksun.',
  open_page: 'Avaa maksusivu sen sijaan',
  expired: 'Tämä Pix-koodi on vanhentunut. Aloita maksu uudelleen saadaksesi uuden.',
  cancel: 'Peruuta maksu',
  checking: 'Tarkistetaan maksuasi…',
  close: 'Sulje',
};
